import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {ContentSectionModule} from '../../../../craft/content-section/content-section.module'
import {TranslocoModule} from '@ngneat/transloco'
import {ReviewsSectionComponent} from './reviews-section.component'
import {ReviewCardComponent} from './review-card/review-card.component'
import {SliderModule} from '../../../../craft/slider/slider.module'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {RatingModule} from '../../../../craft/rating/rating.module'

@NgModule({
  declarations: [ReviewsSectionComponent, ReviewCardComponent],
  imports: [CommonModule, ContentSectionModule, TranslocoModule, SliderModule, FontAwesomeModule, RatingModule],
  exports: [ReviewsSectionComponent],
})
export class ReviewsSectionModule {}
